import { StoryNode } from "../StoryBook/StoryData";
import React from "react";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { ObserveState } from "./ObserveState";
import { TextField } from "@mui/material";
import { Box } from "@mui/system";

class OSData {
    private _name: string = "joe";

    get name(): string {
        return this._name;
    }

    setName(value: string) {
        this._name = value;
        StateManager.changed(this);
    }
}

export function OS2View(props: { data: OSData }) {
    let d = props.data;

    return (
        <Box
            display={"flex"}
            flexDirection={"column"}
        >
            <ObserveState
                listenTo={d}
                control={() => {
                    return (
                        <TextField
                            value={d.name}
                            onChange={(e) => {
                                d.setName(e.target.value);
                            }}
                        ></TextField>
                    );
                }}
            ></ObserveState>
            <div>Observe State</div>
            <ObserveState
                listenTo={d}
                control={() => {
                    return <div>{d.name}</div>;
                }}
            ></ObserveState>
        </Box>
    );
}

export const ObserveStateStories = [
    new StoryNode(
        () => {
            return <OS2View data={new OSData()} />;
        },
        "Shared",
        "Observe State",
    ),
];
